import React, { useState, useEffect } from "react";
import Menu from "../Menu/Menu";
import Content from "../Content/Content";
import AnnouncementPage from "../AnnouncementPage/AnnouncementPage";
import Student from "../Student/Student";
import Attendance from "../Attendance/Attendance";
import Teacher from "../Teacher/Teacher";
import CircularPage from "../Circularpage/Circularpage";
import Assignmentpage from "../Assignmentpage/Assignmentpage";
// import AdmissionList from "../AdmissionList/AdmissionList";  // Removed
import Admin from "../Admin/Admin";
import PrivacyPolicy from "../Privacypolicy/Privacypolicy";
import TermsOfUse from "../Terms/Terms";
import AttendanceReport from "../AttendanceReport/AttendanceReport";
import AssignmentReport from "../AssignmentReport/AssignmentReport";
import ResultReport from "../ResultsReport/MainReport";
import PerformanceReport from "../PerformanceReport/PerformanceReport";
import Enquiries from "../Enquiries/Enquiries";
// import AddApplication from "../ApplicationList/ApplicationList";  // Removed
import AdmissionsList from "../AdmissionsList/AdmissionList";
import WithdrawalList from "../WithdrawalList/WithdrawalList"; // ✅ NEW

import "./Hero.css";

function Hero() {
  const [activePage, setActivePage] = useState(
    localStorage.getItem("activePage") || "Overview"
  );
  const [isMenuOpen, setIsMenuOpen] = useState(
    JSON.parse(localStorage.getItem("isMenuOpen")) ?? true
  );

  useEffect(() => {
    localStorage.setItem("activePage", activePage);
  }, [activePage]);

  useEffect(() => {
    localStorage.setItem("isMenuOpen", JSON.stringify(isMenuOpen));
  }, [isMenuOpen]);

  const renderPage = () => {
    switch (activePage) {
      case "Overview":
        return <Content />;
      case "Announcement":
        return <AnnouncementPage />;
      // case "AdmissionList":
      //   return <AdmissionList />;   // Removed
      case "Student":
        return <Student />;
      case "Teacher":
        return <Teacher />;
      case "Attendance":
        return <Attendance />;
      case "Circular":
        return <CircularPage />;
      case "Assignment":
        return <Assignmentpage />;
      case "Admin":
        return <Admin />;
      case "PrivacyPolicy":
        return <PrivacyPolicy />;
      case "TermsOfUse":
        return <TermsOfUse />;
      case "AttendanceReport":
        return <AttendanceReport />;
      case "AssignmentReport":
        return <AssignmentReport />;
      case "ResultReport":
        return <ResultReport />;
      case "PerformanceReport":
        return <PerformanceReport />;
      case "Enquiries":
        return <Enquiries />;
      // case "Application":
      //   return <AddApplication />;  // Removed
      case "AdmissionsList":
        return <AdmissionsList />;
      case "WithdrawalList":
        return <WithdrawalList />;
      default:
        return <Content />;
    }
  };

  return (
    <div className={`hero ${isMenuOpen ? "menu-open" : "menu-closed"}`}>
      <Menu
        onMenuClick={setActivePage}
        isOpen={isMenuOpen}
        toggleMenu={() => setIsMenuOpen(!isMenuOpen)}
      />
      <div className={`page-content ${isMenuOpen ? "expanded" : "full-width"}`}>
        {renderPage()}
      </div>
    </div>
  );
}

export default Hero;
